import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
type Jwks = { keys: any[] };

export async function createAuthConfig(): Promise<AuthConfig> {
  const jwks = await fetchJWKS();

  return {
    issuer: 'https://auth.promob.com/',
    redirectUri: window.location.origin + '/',
    clientId: environment.clientId,
    scope: 'openid',
    tokenEndpoint: 'https://auth.promob.com/promobazure.onmicrosoft.com/oauth2/token',
    loginUrl: 'https://auth.promob.com/promobazure.onmicrosoft.com/oauth2/authorize',
    logoutUrl: `https://auth.promob.com/promobazure.onmicrosoft.com/oauth2/logout?{{client_id}}&post_logout_redirect_uri=${window.location.origin}/`,
    jwks: jwks
  };
}

async function fetchJWKS(): Promise<Jwks> {
  const url = "https://auth.promob.com/.well-known/jwks";
  const resp = await fetch(url, { cache: 'no-store' });

  if (!resp.ok) {
    throw new Error(`Falha ao buscar JWKS: ${resp.status} ${resp.statusText}`);
  }

  const data = await resp.json();
  return data as Jwks;
}
